module.exports = __webpack_public_path__ + "img/logo-shanita.5437345c.png";